import { render, staticRenderFns } from "./UserRoleRules.vue?vue&type=template&id=a9289a40&scoped=true"
import script from "./UserRoleRules.vue?vue&type=script&lang=js"
export * from "./UserRoleRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9289a40",
  null
  
)

export default component.exports